/* quick-view-variant-gallery.debug.js
   Debug: logs why quick-view gallery image does/doesn't change
*/
(() => {
  if (window.__QV_VARIANT_GALLERY_DEBUG__) return;
  window.__QV_VARIANT_GALLERY_DEBUG__ = true;

  const TAG = '[QV-Gallery]';
  const log  = (...a) => console.log(TAG, ...a);
  const warn = (...a) => console.warn(TAG, ...a);
  const err  = (...a) => console.error(TAG, ...a);

  const getQVInfo = () => {
    const el = document.querySelector('quick-view-modal .quick-view__content product-info[data-view-mode="quick-view"]');
    log('getQVInfo =>', el);
    return el;
  };

  const getGallery = (info) => {
    if (!info) { warn('getGallery: no info'); return null; }
    const sectionId = info.dataset.section;
    const gal = info.querySelector(`#MediaGallery-${CSS.escape(sectionId)}`);
    log('getGallery: sectionId=', sectionId, 'gallery=', gal);
    return gal;
  };

  const getVariantFromInfo = (info) => {
    const el = info?.querySelector('[type="application/json"][data-selected-variant]');
    if (!el) { warn('getVariantFromInfo: data-selected-variant not found'); return null; }
    try {
      const v = JSON.parse(el.textContent || '{}');
      log('getVariantFromInfo:', v);
      return v;
    } catch (e) {
      err('getVariantFromInfo: JSON parse failed', e);
      return null;
    }
  };

  function slideToMedia(gallery, mediaId) {
    if (!gallery) { warn('slideToMedia: no gallery'); return false; }
    if (!mediaId)  { warn('slideToMedia: no mediaId'); return false; }

    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    const swiper =
      gallery.sliderInstance?.slider ||
      (viewer ? viewer.swiper : null) ||
      null;

    log('slideToMedia: swiper=', swiper);

    const slides = Array.from(
      gallery.querySelectorAll('[id^="Slider-Gallery-"] .product__media-item')
    );
    const ids = slides.map(s => s.dataset.mediaId);
    log('slideToMedia: slides count=', slides.length, 'mediaIds=', ids);

    const idx = slides.findIndex(s => String(s.dataset.mediaId) === String(mediaId));
    log('slideToMedia: target mediaId=', mediaId, 'found idx=', idx);

    if (idx === -1) return false;
    if (!swiper) { warn('slideToMedia: swiper instance not found; cannot slide'); return false; }

    if (typeof swiper.slideToLoop === 'function') {
      log('slideToMedia: using slideToLoop(', idx, ')');
      swiper.slideToLoop(idx);
    } else {
      log('slideToMedia: using slideTo(', idx, ')');
      swiper.slideTo(idx);
    }
    return true;
  }

  function swapFirstSlideAndThumb(gallery, variant) {
    if (!gallery) { warn('swapFirstSlideAndThumb: no gallery'); return; }
    if (!variant?.featured_media) { warn('swapFirstSlideAndThumb: no featured_media on variant', variant); return; }

    const mediaId = String(variant.featured_media.id);
    const imgUrl  = variant.featured_media.preview_image?.src || variant.featured_image?.src;
    const alt     = variant.title || '';

    log('swapFirstSlideAndThumb: mediaId=', mediaId, 'imgUrl=', imgUrl);

    if (!imgUrl) { warn('swapFirstSlideAndThumb: variant has no image URL'); return; }

    const firstSlide = gallery.querySelector('[id^="Slider-Gallery-"] .product__media-item');
    const img = firstSlide?.querySelector('img');
    log('swapFirstSlideAndThumb: firstSlide=', firstSlide, 'img=', img);

    if (firstSlide && img) {
      firstSlide.dataset.mediaId = mediaId;
      firstSlide.setAttribute('data-media-id', mediaId);
      firstSlide.setAttribute('data-src', imgUrl);
      img.src = imgUrl;
      img.removeAttribute('srcset'); // clear stale srcset
      img.alt = alt;
      log('swapFirstSlideAndThumb: viewer image swapped');
    } else {
      warn('swapFirstSlideAndThumb: could not find first viewer slide/img');
    }

    const firstThumbImg = gallery.querySelector('[id^="Slider-Thumbnails-"] .product__thumbs-item img');
    log('swapFirstSlideAndThumb: firstThumbImg=', firstThumbImg);

    if (firstThumbImg) {
      firstThumbImg.src = imgUrl;
      firstThumbImg.removeAttribute('srcset');
      firstThumbImg.alt = alt;
      const thumbItem = firstThumbImg.closest('.product__thumbs-item');
      if (thumbItem) {
        thumbItem.dataset.target = mediaId;
        thumbItem.setAttribute('data-target', mediaId);
      }
      log('swapFirstSlideAndThumb: thumb swapped');
    } else {
      warn('swapFirstSlideAndThumb: no thumb image found (maybe thumbs disabled in QV)');
    }
  }

  function updateQuickViewGallery(variant) {
    log('updateQuickViewGallery: variant=', variant);
    const info = getQVInfo();
    if (!info) { warn('updateQuickViewGallery: no product-info'); return; }
    const gallery = getGallery(info);
    if (!gallery) { warn('updateQuickViewGallery: gallery not found in QV'); return; }

    const mediaId = variant?.featured_media?.id;
    log('updateQuickViewGallery: featured_media.id=', mediaId);

    // 1) try to go to the existing media slide
    const moved = slideToMedia(gallery, mediaId);
    log('updateQuickViewGallery: slideToMedia moved=', moved);
    if (moved) return;

    // 2) else swap the first slide/thumbnail so the hero shows the variant image
    log('updateQuickViewGallery: fallback to swap first slide');
    swapFirstSlideAndThumb(gallery, variant);
  }

  // When QV DOM is injected
  document.addEventListener('quick-view:loaded', (e) => {
    log('event: quick-view:loaded detail=', e?.detail);
    const info = getQVInfo();
    if (!info) return;

    // Initial sync
    const v0 = getVariantFromInfo(info);
    if (v0?.id) updateQuickViewGallery(v0);
    else warn('on loaded: no initial variant');

    // variant-selects emits custom event
    info.querySelectorAll('variant-selects').forEach(vs => {
      log('binding variant:change on', vs);
      vs.addEventListener('variant:change', (ev) => {
        log('event: variant:change detail=', ev.detail);
        const v = ev.detail?.variant || getVariantFromInfo(info);
        if (v?.id) updateQuickViewGallery(v);
        else warn('variant:change: no variant payload');
      });
    });

    // plain radio fallback
    info.addEventListener('change', () => {
      log('fallback change event inside QV');
      const v = getVariantFromInfo(info);
      if (v?.id) updateQuickViewGallery(v);
      else warn('fallback change: no variant');
    }, { capture: true });
  });

  // Also try once when QV opens
  document.addEventListener('quick-view:open', (e) => {
    log('event: quick-view:open detail=', e?.detail);
    const info = getQVInfo();
    if (!info) return;
    const v = getVariantFromInfo(info);
    if (v?.id) updateQuickViewGallery(v);
  });
})();
